export default {
  name: "SquareArrowButton",
  props: ["type", "title", "contentType"],
  methods: {},
};
